"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as i, jsx as o } from "react/jsx-runtime";
import u from "./box.js";
import a from "./stack.js";
import { useIsInverseVariant as M } from "./theme-variant-context.js";
import T from "./responsive-layout.js";
import B from "./grid-layout.js";
import { useSetOverscrollColor as H } from "./overscroll-color-context.js";
import { Text2 as N, Text3 as x, Text8 as R, Text7 as j, Text6 as A } from "./text.js";
import G from "./button-group.js";
import { vars as n } from "./skins/skin-contract.css-mistica.js";
import { hideOnTabletOrSmaller as O, hideOnDesktop as P, breadcrumbs as V } from "./header.css-mistica.js";
import { getPrefixedDataAttributes as q } from "./utils/dom.js";
import { Title2 as w, Title3 as z } from "./title.js";
const oo = (param)=>{
    let { headline: r, pretitle: e, pretitleAs: t, title: l, titleAs: d = "h2", description: m, dataAttributes: f, small: s = !1, preamount: c, amount: p, button: g, subtitle: k, isErrorAmount: L, secondaryButton: y } = param;
    const S = M(), b = (h, v)=>{
        if (typeof h == "string") return /* @__PURE__ */ o(x, _object_spread_props(_object_spread({
            regular: !0
        }, v), {
            children: h
        }));
        const { text: D } = h, C = _object_without_properties(h, [
            "text"
        ]);
        return /* @__PURE__ */ o(x, _object_spread_props(_object_spread({
            regular: !0
        }, v, C), {
            children: h.text
        }));
    };
    return /* @__PURE__ */ i(a, {
        space: {
            mobile: 24,
            desktop: 32
        },
        dataAttributes: f,
        children: [
            (l || e || m) && /* @__PURE__ */ o(u, {
                paddingRight: 16,
                children: /* @__PURE__ */ i(a, {
                    space: 8,
                    children: [
                        r,
                        e && b(e, {
                            color: n.colors.textPrimary,
                            as: t
                        }),
                        l && (s ? /* @__PURE__ */ o(w, {
                            as: d,
                            children: l
                        }) : /* @__PURE__ */ o(z, {
                            as: d,
                            children: l
                        })),
                        m && (s ? /* @__PURE__ */ o(N, {
                            regular: !0,
                            color: n.colors.textSecondary,
                            children: m
                        }) : /* @__PURE__ */ o(x, {
                            regular: !0,
                            color: n.colors.textSecondary,
                            children: m
                        }))
                    ]
                })
            }),
            (c || p || g || k) && /* @__PURE__ */ i(a, {
                space: 16,
                children: [
                    (c || p) && /* @__PURE__ */ i(a, {
                        space: 8,
                        children: [
                            c && b(c, {
                                color: n.colors.textPrimary
                            }),
                            /* @__PURE__ */ o(R, {
                                color: L && !S ? n.colors.highlight : n.colors.textPrimary,
                                children: p
                            })
                        ]
                    }),
                    (g || y) && /* @__PURE__ */ o(G, {
                        primaryButton: g,
                        secondaryButton: y
                    }),
                    k && b(k, {})
                ]
            })
        ]
    });
}, ro = (param)=>{
    let { title: r, titleAs: e = "h1", description: t, button: l } = param;
    return /* @__PURE__ */ i(a, {
        space: 32,
        children: [
            /* @__PURE__ */ i(a, {
                space: {
                    mobile: 12,
                    desktop: 16
                },
                children: [
                    r && /* @__PURE__ */ o(j, {
                        as: e,
                        children: r
                    }),
                    t && /* @__PURE__ */ o(A, {
                        children: t
                    })
                ]
            }),
            l
        ]
    });
}, eo = (param)=>{
    let { isInverse: r = !0, breadcrumbs: e, header: t, extra: l, sideBySideExtraOnDesktop: d = !1, dataAttributes: m, bleed: f = !1, noPaddingY: s = !1 } = param;
    const c = f && r && l, p = /* @__PURE__ */ i("div", {
        children: [
            e && /* @__PURE__ */ o("div", {
                className: V,
                children: e
            }),
            t
        ]
    });
    return H(r ? {
        topColor: n.colors.backgroundBrandTop
    } : {}), /* @__PURE__ */ i("div", _object_spread_props(_object_spread({}, q(_object_spread({
        "component-name": "HeaderLayout"
    }, m))), {
        children: [
            /* @__PURE__ */ o(T, {
                isInverse: r,
                children: /* @__PURE__ */ o(u, {
                    paddingTop: s ? 0 : {
                        mobile: t ? 32 : 0,
                        desktop: e ? 16 : 48
                    },
                    paddingBottom: {
                        mobile: s && !c ? 0 : 24,
                        desktop: c && !d ? 32 : s ? 0 : 48
                    },
                    children: d ? /* @__PURE__ */ o(B, {
                        template: "6+6",
                        left: p,
                        right: /* @__PURE__ */ o("div", {
                            className: c ? O : "",
                            children: /* @__PURE__ */ o(u, {
                                paddingTop: {
                                    mobile: t ? 24 : 0,
                                    desktop: 0
                                },
                                children: l
                            })
                        })
                    }) : /* @__PURE__ */ i(a, {
                        space: t ? {
                            mobile: 24,
                            desktop: 32
                        } : 0,
                        children: [
                            p,
                            !c && l
                        ]
                    })
                })
            }),
            c && /* @__PURE__ */ o(T, {
                className: d ? P : "",
                backgroundColor: `linear-gradient(to bottom, ${n.colors.backgroundBrandBottom} 40px, ${n.colors.background} 0%)`,
                children: l
            })
        ]
    }));
}, to = (param)=>{
    let { isInverse: r = !0, children: e, dataAttributes: t } = param;
    return H(r ? {
        topColor: n.colors.backgroundBrandTop
    } : {}), /* @__PURE__ */ o(T, {
        isInverse: r,
        dataAttributes: _object_spread({
            "component-name": "MainSectionHeaderLayout"
        }, t),
        children: /* @__PURE__ */ o(B, {
            template: "6+6",
            left: /* @__PURE__ */ o(u, {
                paddingTop: {
                    mobile: 12,
                    desktop: 48
                },
                paddingBottom: {
                    mobile: 24,
                    desktop: 48
                },
                children: e
            }),
            right: null
        })
    });
};
export { oo as Header, eo as HeaderLayout, ro as MainSectionHeader, to as MainSectionHeaderLayout };
